import { ToastContainer, ToastContainerProps } from 'react-toastify';
import { ToastCloseButton } from './ToastCloseButton';

type NotificationsContainerProps = Partial<ToastContainerProps>;

/** Renders a toast container with the shared application defaults. */
export function NotificationsContainer(props: NotificationsContainerProps) {
  return (
    <ToastContainer
      closeButton={ToastCloseButton}
      style={{
        minHeight: '3rem',
        width: '360px',
      }}
      toastStyle={{
        boxShadow:
          '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.05)',
      }}
      progressStyle={{ height: '3px', opacity: 0.5 }}
      key="toast-container"
      autoClose={4000}
      position="bottom-right"
      theme="light"
      {...props}
    />
  );
}
